import{a as i}from"./chunk-Z33GHMNR.js";import{useEffect as n}from"react";var p=({settings:t,children:r})=>{let e=i(o=>o.initSettings);return n(()=>{e(t)},[e,t]),r};export{p as a};
